import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

function useManageCourse() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addCourse(data) {
    return privateFetch.post(`/v1/admin/course`, data);
  }

  function updateCourse(courseID, data) {
    return privateFetch.put(`/v1/admin/course/${courseID}`, data);
  }

  function deleteCourse(courseID) {
    return privateFetch.delete(`/v1/admin/course/${courseID}`);
  }

  function manageCourse({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateCourse(data.id, data);
    }

    if (type === 'DELETE') {
      return deleteCourse(data.id);
    }

    return addCourse(data);
  }

  return useMutation(manageCourse, {
    onSuccess(data, variables) {
      if (variables?.type !== 'DELETE' && variables.status === 'active') history.goBack();
    },
    onSettled() {
      queryClient.invalidateQueries('courses');
    },
  });
}

export default useManageCourse;
